const STORAGE_PREFIX = 'vc_retroceso_visita_visto';

export function claveRetrocesoVisitaVisto(userId, historialId) {
  if (!userId || !historialId) return null;
  return `${STORAGE_PREFIX}:${String(userId)}:${String(historialId)}`;
}

export function yaVioRetrocesoVisita(userId, historialId) {
  const key = claveRetrocesoVisitaVisto(userId, historialId);
  if (!key) return false;
  try {
    return localStorage.getItem(key) === '1';
  } catch {
    return false;
  }
}

export function marcarRetrocesoVisitaVisto(userId, historialId) {
  const key = claveRetrocesoVisitaVisto(userId, historialId);
  if (!key) return;
  try {
    localStorage.setItem(key, '1');
  } catch {
    /* noop */
  }
}

/** Retroceso reciente → omitir aviso teléfono duplicado (relación contacto). */
export function esRetrocesoVisitaReciente(createdAt, dias = 14) {
  if (!createdAt) return false;
  const t = Date.parse(String(createdAt));
  if (!Number.isFinite(t)) return false;
  return Date.now() - t < dias * 24 * 60 * 60 * 1000;
}
